import DashboardAboutSection from "./components/AboutSection"
import DashboardEventsSection from "./components/EventsSection"
import DashboardHero from "./components/Hero"
import DashboardMembersSection from "./components/MembersSection"



function DashboardHome() {
  return <>
  <div>Bu Sayfa Private Home Sayfasıdır</div>
    <div>
        <DashboardAboutSection/>
        <DashboardEventsSection/>
        <DashboardHero/>
        <DashboardMembersSection/>

        </div>
  </>
}

export default DashboardHome